export const removeUnderscore = (key: string) => key.replaceAll("_", " ");
